module.exports = __webpack_public_path__ + "static/media/logo.3d694d68.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/brand/brands/dif/media/logo.png
// module id = 867
// module chunks = 0